import { useCallback, useState } from 'react';
import { TSortValue } from '~/commonComponents';
import {
  OnsiteInterviewSortableField,
  OnsiteInterviewStatus,
  useGetOnsiteInterviewList,
  useGetOnsiteInterviewStatusCount,
} from '~/domain/PermanentJobs';

const DEFAULT_SORTING: TSortValue = {
  direction: 'ASC',
  field: OnsiteInterviewSortableField.JobDateTime,
};

export const useOnsiteInterviewTabView = (jobPostingId: string) => {
  const [formStatus, setFormStatus] = useState<OnsiteInterviewStatus | 'all'>('all');
  const [formSorting, setFormSorting] = useState<TSortValue>(DEFAULT_SORTING);
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isInitialLoading, isLoading, pagination } = useGetOnsiteInterviewList({
    jobPostingId,
    orderBy: formSorting.field as OnsiteInterviewSortableField,
    orderDirection: formSorting.direction,
    page: currentPage,
    status: formStatus,
  });
  const { statistic } = useGetOnsiteInterviewStatusCount({ jobPostingId });

  const handleStatusFilterChange = useCallback((status: OnsiteInterviewStatus | 'all') => {
    setFormStatus(status);
    setCurrentPage(1);
  }, []);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  const handleSetFormSorting = (value: TSortValue | undefined) => {
    setFormSorting(value === undefined ? DEFAULT_SORTING : value);
    setCurrentPage(1);
  };

  return {
    data,
    filters: {
      sorting: formSorting,
      status: formStatus,
    },
    isInitialLoading,
    isLoading,
    methods: {
      setCurrentPage: handlePageChange,
      setStatusFilter: handleStatusFilterChange,
      setSorting: handleSetFormSorting,
    },
    pagination: {
      currentPage,
      totalPages: pagination.totalPages,
    },
    statistic,
  };
};
